import { GetItemsProps, useApiService } from "medere-ui-framework";
import { MedereEntityContactDTO } from "../../interface/MedereEntityContactDTO";

export function useContactsService() {
  const { api, getMethod, tableMethod } = useApiService();
  const baseEndpoint = "/api/secured/contacts";

  function getEntityContacts(offSet: number, pageSize: number, params: any): Promise<MedereEntityContactDTO[]> {
    return tableMethod<MedereEntityContactDTO[]>({
      basePath: baseEndpoint,
      endpoint: "/getEntityContacts",
      bodyTable: {
        offSet,
        pageSize,
        sortingFieldInfoList: params.multiSortMeta,
        filters: params.filterDTO
      },
      params: { medereentity: params.medereentity }
    });
  }

  function getMedereEntityContact(medereentity: number, contactId: number) {
    return api.get(`${baseEndpoint}/getMedereEntityContact`, {
      params: {
        offSet: 0,
        pageSize: 0,
        medereentity,
        contactId
      }
    }).then((response) => {
      return response.data;
    }).catch((error) => {
      console.error(error);
      throw error;
    });
  }

  function deleteContact(contactid: number) {
    return api.post(`${baseEndpoint}/deleteContact`, null, {
      params: { contactid }
    }).then(res => res);
  }

  function createContact(dto: MedereEntityContactDTO) {
    return api.post(`${baseEndpoint}/createContact`, dto).then(res => res);
  }

  function updateContact(dto: MedereEntityContactDTO) {
    return api.post(`${baseEndpoint}/updateContact`, dto).then(res => res);
  }

  function getProfessionalContactsTypes({ offSet, pageSize, filterValue }: GetItemsProps) {
    return getMethod({
      basePath: baseEndpoint,
      endpoint: "/getProfessionalContactsTypes",
      params: {
        inputText: filterValue,
        offSet,
        pageSize
      }
    });
  }

  return {
    getEntityContacts,
    getMedereEntityContact,
    deleteContact,
    createContact,
    updateContact,
    getProfessionalContactsTypes
  };
}
